import React from 'react';

/**
 * Shimmer skeleton placeholders for enterprise loading states.
 *
 * variant:
 *  - "cards"  → a grid of stat-card placeholders (count via `count`)
 *  - "rows"   → stacked row placeholders (count via `count`)
 *  - "block"  → a single tall block placeholder
 */
export default function EntSkeleton({ variant = 'rows', count = 4 }) {
  if (variant === 'cards') {
    return (
      <div className="ent-skeleton-cards" aria-hidden="true">
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="ent-skeleton ent-skeleton-card" />
        ))}
      </div>
    );
  }

  if (variant === 'block') {
    return <div className="ent-skeleton ent-skeleton-block" aria-hidden="true" />;
  }

  return (
    <div aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="ent-skeleton ent-skeleton-row" />
      ))}
    </div>
  );
}
